import { LastTransaction } from '@pos/app/scripts/services/last-transaction';
import { Sales } from '@shared/app/scripts/services/sales';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

/*
 * Service printLastReceipt - prints the last receipt
 */
angular
  .module('posApp')
  .factory(
    'printLastReceipt',
    (
      $q: ng.IQService,
      lastTransaction: LastTransaction,
      legacyPrint,
      pos,
      printCoupon,
      reprintReceipt,
      sales: Sales,
      settingsManager: SettingsManager,
    ) => {
      // TODO move this logic to the print service in v7/shared
      const printLastReceipt = () => {
        const partialTransaction = lastTransaction.get();

        printCoupon(partialTransaction);

        if (settingsManager.settings.fiscalPrinter?.active) {
          return sales.get(partialTransaction?._id).then((transaction) => {
            return reprintReceipt(transaction);
          });
        } else {
          if (partialTransaction) {
            return legacyPrint.receipt(partialTransaction, true);
          } else {
            return $q.reject();
          }
        }
      };

      return printLastReceipt;
    },
  );
